import { createStorefrontApiClient } from '@shopify/storefront-api-client'

export const storefrontClient = createStorefrontApiClient({
  storeDomain: 'https://butter-sessions.myshopify.com',
  apiVersion: '2025-10',
  publicAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN || '',
  clientName: 'butter-sessions-storefront'
})
